import { render } from "./TeamForm.vue?vue&type=template&id=36bfbd73"
import script from "./TeamForm.vue?vue&type=script&lang=js"
export * from "./TeamForm.vue?vue&type=script&lang=js"

import "./TeamForm.vue?vue&type=style&index=0&id=36bfbd73&lang=scss"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__